import {
  LOAD_COMPANY_SENDING_TEST_SETTINGS_REQUEST,
  LOAD_COMPANY_SENDING_TEST_SETTINGS_SUCCESS,
  LOAD_COMPANY_SENDING_TEST_SETTINGS_FAILURE,
  LOAD_TESTS_REQUEST,
  LOAD_TESTS_SUCCESS,
  LOAD_TESTS_FAILURE,
  POST_SEND_TEST_REQUEST,
  POST_SEND_TEST_SUCCESS,
  POST_SEND_TEST_FAILURE,
  RESET_STATE,
} from './constants';
import { logError } from 'global/errors';
import services from 'api/services';
const { CompanyService, TestService, TicketService } = services;

export const loadCompanySendingTestSettings = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_COMPANY_SENDING_TEST_SETTINGS_REQUEST });
    const companySettings = await CompanyService.loadCompanySendingTestSettings();
    dispatch({ type: LOAD_COMPANY_SENDING_TEST_SETTINGS_SUCCESS, companySettings });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_COMPANY_SENDING_TEST_SETTINGS_FAILURE, error: ex.message });
  }
};

export const loadTests = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_TESTS_REQUEST });
    const tests = await TestService.getTestsOfSendTestPage();
    dispatch({ type: LOAD_TESTS_SUCCESS, tests });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_TESTS_FAILURE, error: ex.message });
  }
};

export const sendTicket = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_SEND_TEST_REQUEST });
    const sendTestResult = await TicketService.sendTicket(data);
    dispatch({ type: POST_SEND_TEST_SUCCESS, sendTestResult });
  } catch (ex) {
    logError(ex);
    dispatch({ type: POST_SEND_TEST_FAILURE, error: ex.message });
  }
};

export const resetStateResponse = () => async (dispatch) => {
  dispatch({ type: RESET_STATE });
};
